import { CardHeader } from '@material-ui/core'
import { AvatarProps } from '@material-ui/core/Avatar'
import cx from 'clsx'
import { ReactElement } from 'react'

interface QAHeaderProps {
  title: string
  titleClass?: string
  avatar?: ReactElement<AvatarProps>
}
export function QAHeader({ title, titleClass, avatar }: QAHeaderProps) {
  return (
    <CardHeader
      title={title}
      titleTypographyProps={
        {
          className: cx(titleClass, 'faq-panel-header__title'),
          variant: 'h3',
          component: 'h3',
        } as any
      }
      className={cx('faq-panel-header')}
      avatar={avatar}
    />
  )
}
